import $ from 'jquery';
import 'jquery.easing';
import inView from 'in-view';
import imagesLoaded from 'imagesloaded';

function init() {
  addSpanTag();
  inview();
  loadingInit();
  pageScroll();
}

function inview() {
  inView.offset(150);
  inView('.c-inview').on('enter', el => {
    $(el).addClass('-visible');
    $(el).css('opacity', '1');
  });
}

function loadingInit() {
  const $loader = $('#c-loading');

  if (!$loader[0]) {
    return;
  }

  const lochref = window.location.href;

  if (lochref.indexOf('#') > -1) {
    const anchor = lochref.slice(lochref.indexOf('#'));

    window.setTimeout(() => {
      $('body, html').animate({ scrollTop: $(anchor).offset().top, }, 1);
    }, 1);
  }

  // $('html,body').animate({ scrollTop: 0, }, '1');

  // $('body').addClass('-fixed');
  $loader.find('.c-loading__logo').addClass('-visible');

  imagesLoaded($loader, { background: true, }, () => {
    setTimeout(() => {
      $loader.find('.c-loading__logo').removeClass('-visible');
    }, 1800);

    setTimeout(() => {
      // $('body').removeClass('-fixed');
      $loader.fadeOut(1400, () => {
        $loader.remove();
      });
    }, 2500);
  });
}

function pageScroll() {
  const $elm = $('.c-pageScroll');
  const $burger = $('#l-header__burger');
  const $nav = $('#l-header__nav');

  if (!$elm[0]) {
    return;
  }

  $elm.on('click', (e) => {
    const speed = 1800;
    const href = $(e.currentTarget).attr('href');
    const target = $(href === '#' || href === '' ? 'html' : href);
    const position = target.offset().top;

    $('body,html').animate({ scrollTop: position, }, speed, 'easeOutExpo', () => {
      if ($('body').hasClass('-fixed')) {
        $('body').removeClass('-fixed');
      }

      if ($burger[0] && $burger.hasClass('-active')) {
        $burger.removeClass('-active');
        $nav.fadeOut();
      }
    });

    return false;
  });
}

function delayTextInit() {
  $(window).on('scroll', () => {
    delayTextAnimation();/* アニメーション用の関数を呼ぶ*/
  });
}

function delayTextAnimation() {
  const $elm = $('.c-delayText');

  if (!$elm[0]) {
    return;
  }

  $elm.each((i, el) => {
    const $this = $(el);
    const elemPos = $this.offset().top - 50;
    const scroll = $(window).scrollTop();
    const windowHeight = $(window).height();

    if (scroll >= elemPos - windowHeight) {
      $this.addClass('-visible');
    } else {
      $this.removeClass('-visible');
    }
  });
}

function addSpanTag() {
  const $elm = $('.c-delayText');

  if (!$elm[0]) {
    return;
  }

  $elm.each((j, el) => {
    const $this = $(el);
    const text = $this.text();
    let textbox = '';

    text.split('').forEach((t, i) => {
      if (t !== ' ') {
        if (i < 10) {
          textbox += `<span class="c-delayText__letter" style="transition-delay:.${i}s;">${t}</span>`;
        } else {
          const n = i / 10;

          textbox += `<span class="c-delayText__letter" style="transition-delay:${n}s;">${t}</span>`;
        }

      } else {
        textbox += t;
      }
    });
    $this.html(textbox);
  });

  delayTextInit();
}

export default {
  init,
};
